import {
  RiLineChartLine,
  RiMenuLine,
  RiToolsLine,
  RiUserStarFill,
} from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { i18n } from "../../../localization/i18n";
import { MenuButton, MenuItemContainer } from "../styles";

interface MenuListProps {
  extendedMode: boolean;
}

export const SafMenuList = ({ extendedMode }: MenuListProps) => {
  const location = useLocation();

  const tooltipProps = {
    tooltip: {
      sx: {
        backgroundColor: "var(--dark-gray)",
        color: "var(--white)",
        fontSize: "14px",
        fontWeight: "500",
        padding: "8px 14px",
        borderRadius: "6px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
      }
    },
    arrow: {
      sx: {
        color: "var(--dark-gray)"
      }
    }
  };

  return (
    <>
      <MenuItemContainer>
        <Link to="/saf/dashboard">
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.reports")}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} isActive={location.pathname.includes("/saf/dashboard")}>
                <div className="content">
                  <RiLineChartLine size={24} />
                  <span>{`${i18n.t("sidebar.reports")}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        <Link to="/saf/orders">
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.requests")}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} isActive={location.pathname.includes("/saf/orders")}>
                <div className="content">
                  <RiMenuLine size={24} />
                  <span>{`${i18n.t("sidebar.requests")}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        <Link to="/saf/licensees">
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.licensees")}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} isActive={location.pathname.includes("/saf/licensees")}>
                <div className="content">
                  <RiUserStarFill size={24} />
                  <span>{`${i18n.t("sidebar.licensees")}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        <Link to="/saf/configs">
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.config")}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} isActive={location.pathname.includes("/saf/configs")}>
                <div className="content">
                  <RiToolsLine size={24} />
                  <span>{`${i18n.t("sidebar.config")}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>
    </>
  );
};


